<template>
	<toolbar-button
		v-if="selected"
		v-show="selected.length != 0"
		icon="mdi-file-move"
		tooltip="Move Content"
		@click="onMoveItem"
		:button="{ color: 'success', disabled: selected.length < 1 }"
	></toolbar-button>
</template>

<script>
import { PtModal } from 'plant-common';
import MoveToDialog from './MoveToDialog';
import ToolbarButton from './ToolbarButton';
import { mapState, mapActions } from 'vuex';
import { STORE_EXPLORER_NAME, STATE_FOLDER, STATE_SELECTED, ACTION_REFRESH } from '@/store_constants/explorer';
import { moveFolder } from './moveFolder';
import { moveContent } from './moveContent';

export default {
	mixins: [PtModal],
	components: { ToolbarButton, MoveToDialog },
	computed: {
		...mapState(STORE_EXPLORER_NAME, {
			folder: STATE_FOLDER,
			selected: STATE_SELECTED
		})
	},
	methods: {
		...mapActions(STORE_EXPLORER_NAME, {
			refresh: ACTION_REFRESH
		}),
		async moveSingleItem(item, parentId) {
			try {
				const isFolder = !item.header;

				if (isFolder) {
					await moveFolder(item, parentId);
				} else {
					await moveContent(item, parentId);
				}

				return null;
			} catch (e) {
				console.log(e);
				return e.response?.data?.message || 'Unknown error';
			}
		},
		async moveItemsTo(parentId) {
			const promises = this.selected.map(item => this.moveSingleItem(item, parentId));
			const results = await Promise.all(promises);

			return results.filter(Boolean);
		},
		async onMoveItem() {
			const destination_folder_id = await this.$modal(MoveToDialog, { selected: this.selected });
			if (!destination_folder_id) return;

			let parentId = destination_folder_id;
			if (destination_folder_id === '$root') {
				parentId = undefined;
			}

			const errorMessages = await this.moveItemsTo(parentId);
			if (errorMessages.length > 0) {
				await this.$modal('info', { title: 'Error moving items', message: errorMessages.join('\n') });
			}

			this.refresh();
		}
	}
};
</script>
